import React, { useState } from 'react';
import { Button, Card, Dropdown, Form, Modal } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import SubtleBadge from 'components/common/SubtleBadge';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import PropTypes from 'prop-types';
import FalconCloseButton from 'components/common/FalconCloseButton';
import {
  sendCustomEmail,
  sendNotification
} from 'nursd-dashboard/api/webNotification';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { useAuth } from 'nursd-dashboard/context/AuthContext';

const format = value => {
  const inputPhoneNumber = value.replace(/\D/g, '');
  const limitedPhoneNumber = inputPhoneNumber?.slice(0, 10);
  const formattedPhoneNumber =
    limitedPhoneNumber?.length === 10
      ? limitedPhoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
      : limitedPhoneNumber;
  return formattedPhoneNumber;
};

const NurseTable = ({ data, updateUser, updateUserSuspend }) => {
  const { authToken } = useAuth();
  const [showModel, setShowModel] = useState(false);
  const [obj, setObj] = useState(undefined);
  const [content, setContent] = useState('');

  const handleClose = () => {
    setShowModel(false);
    setObj(undefined);
    setContent('');
  };

  const handleChange = ({ target }) => {
    setContent(target.value);
  };

  // const handleShow = e => {
  //   setShowModel(true);
  //   setObj(e);
  // };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Name',
      meta: {
        headerProps: { className: 'pe-1 text-900' },
        cellProps: {
          className: 'py-2'
        }
      },
      cell: ({ row: { original } }) => {
        const { id, name, profileImage } = original;
        return (
          <Link to={paths.nursd_profile(id, 'profile')}>
            <Flex alignItems="center">
              {profileImage ? (
                <Avatar src={profileImage} size="xl" className="me-2" />
              ) : (
                <Avatar size="xl" name={name} className="me-2" />
              )}
              <div className="flex-1">
                <h5 className="mb-0 fs-10">{name}</h5>
              </div>
            </Flex>
          </Link>
        );
      }
    },
    {
      accessorKey: 'primaryLicenseType',
      header: 'License',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { primaryLicenseType } = original;
        return <p>{primaryLicenseType}</p>;
      }
    },
    {
      accessorKey: 'emailId',
      header: 'Email',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { emailId } = original.original;
        return <a href={`mailto:${emailId}`}>{emailId}</a>;
      }
    },
    {
      accessorKey: 'phoneNumber',
      header: 'Phone',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { phoneNumber } = original.original;
        return <a href={`tel:${phoneNumber}`}>{format(phoneNumber)}</a>;
      }
    },
    // {
    //   accessorKey: 'fullAddress',
    //   header: 'Address',
    //   meta: {
    //     headerProps: {
    //       style: { minWidth: '200px' },
    //       className: 'ps-5 text-900'
    //     },
    //     cellProps: { className: 'ps-5' }
    //   },
    //   cell: ({ row: { original } }) => {
    //     const { fullAddress } = original.original;
    //     return (
    //       <a
    //         href={`https://maps.google.com/?q=${fullAddress}`}
    //         target="_blank"
    //         rel="noreferrer"
    //       >
    //         {Shortened(fullAddress)}
    //       </a>
    //     );
    //   }
    // },
    {
      accessorKey: 'upload',
      header: 'Document',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { id } = original.original;
        return (
          <Link to={paths.nursd_profile(id, 'documents')}>
            <Button size="sm">Upload</Button>
          </Link>
        );
      }
    },
    {
      accessorKey: 'nurseLoginControl',
      header: 'Status',
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { nurseLoginControl, nurseAppAccessControl } = original.original;
        return (
          <Flex>
            <SubtleBadge pill bg={nurseLoginControl ? 'success' : 'danger'}>
              {nurseLoginControl ? 'Active' : 'Deactived'}
            </SubtleBadge>
            {nurseLoginControl && nurseAppAccessControl && (
              <SubtleBadge
                className="mx-2"
                pill
                bg={nurseAppAccessControl ? 'danger' : 'success'}
              >
                {nurseAppAccessControl ? 'Suspended' : 'Unsuspend'}
              </SubtleBadge>
            )}
          </Flex>
        );
      }
    },
    {
      accessorKey: 'none',
      header: '',
      enableSorting: false,
      meta: {
        cellProps: {
          className: 'text-end'
        }
      },
      cell: ({ row: { original } }) => {
        const {
          id,
          firstName,
          lastName,
          nurseLoginControl,
          nurseAppAccessControl
        } = original.original;
        let name = firstName + ' ' + lastName;
        return (
          <Flex justifyContent={'end'}>
            {/* <IconItem
              tag="button"
              icon={'envelope-open'}
              size="sm"
              className="btn rounded-3"
              onClick={() => {
                handleShow(original.original);
              }}
            /> */}
            <CardDropdown>
              <div className="py-2">
                <Dropdown.Item
                  onClick={() =>
                    nurseLoginControl
                      ? updateUser(
                          id,
                          {
                            nurseLoginControl: false
                          },
                          name,
                          'Deactivate'
                        )
                      : updateUser(
                          id,
                          {
                            nurseLoginControl: true
                          },
                          name,
                          'Activate'
                        )
                  }
                >
                  {nurseLoginControl ? 'Deactivate' : 'Activate'}
                </Dropdown.Item>
                {nurseLoginControl && (
                  <Dropdown.Item
                    onClick={() =>
                      nurseAppAccessControl
                        ? updateUserSuspend(
                            id,
                            {
                              nurseAppAccessControl: false
                            },
                            name,
                            'Unsuspend'
                          )
                        : updateUserSuspend(
                            id,
                            {
                              nurseAppAccessControl: true
                            },
                            name,
                            'Suspend'
                          )
                    }
                  >
                    {nurseAppAccessControl ? 'Unsuspend' : 'Suspend'}
                  </Dropdown.Item>
                )}
              </div>
            </CardDropdown>
          </Flex>
        );
      }
    }
  ];

  const sendEmail = async () => {
    // console.log(obj);
    if (obj?.mobileId) {
      sendNotification(authToken, {
        expoPushToken: obj?.mobileId,
        title: `Email Alert`,
        body: `Check your email.`,
        data: { screen: 'NotificationScreen' }
      });
    }
    await postNurseNotification(
      authToken,
      obj?.id,
      '',
      'Email Alert',
      'Check your email.',
      'NotificationScreen',
      {},
      false,
      false,
      'green',
      ''
    );
    sendCustomEmail(authToken, {
      email: obj?.emailId,
      name: obj?.firstName + ' ' + obj?.lastName,
      subject: 'Email Alert',
      content: '',
      body: content
    });
    handleClose();
  };

  const table = useAdvanceTable({
    data: data,
    columns,
    // selection: true,
    sortable: true,
    pagination: true,
    perPage: 10
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card className="mb-3">
          <Card.Body className="p-0">
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
          </Card.Body>
          <Card.Footer>
            <div className="mt-3">
              <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
            </div>
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>
      <Modal
        show={showModel}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Email Alert</Modal.Title>
          <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2" controlId="content">
            <Form.Label className="fs-9">Content</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="content"
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => sendEmail()}>
            Send Email
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

NurseTable.propTypes = {
  data: PropTypes.any,
  updateUser: PropTypes.any,
  updateUserSuspend: PropTypes.any
};

export default NurseTable;
